module.exports = __webpack_public_path__ + "img/bytedance-taps-sesac-to-manage-titktok-rights-administration.475647e3.jpg";